import React, { useRef } from "react";
import { PlatformSidebar } from "../components/layout";
import { useScrollRestoration } from "../hooks";

interface PageLayoutProps {
  children: React.ReactNode;
}

/**
 * A layout component that provides the standard page structure with sidebar and content area.
 * Used across all feature pages for consistent layout.
 *
 * The content area is the app's single scroll container. Each page lives under
 * its own route, so navigating between tabs unmounts this component and would
 * otherwise reset the scroll to the top; useScrollRestoration remembers the
 * offset per route and restores it on return, matching the per-tab data caches.
 */
export function PageLayout({ children }: PageLayoutProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  useScrollRestoration(scrollRef);

  return (
    <div ref={scrollRef} className="w-full h-full overflow-y-auto flex">
      <PlatformSidebar />
      <div className="flex-1 ml-48">
        {children}
      </div>
    </div>
  );
}
